import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "el-text__primary" }, " Help Section ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "" }, " Need help using the site? Select from one of the options below to learn more about using Matrix for Direct Sell (MxB-DS). ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  href: "/help/usingthesite",
  class: "box border-rounded"
}, [
  /*#__PURE__*/_createElementVNode("h3", null, "Using the Site")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", {
  href: "/help/dashboards",
  class: "box border-rounded"
}, [
  /*#__PURE__*/_createElementVNode("h3", null, "Dashboards")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("a", {
  href: "/help/faqs",
  class: "box border-rounded"
}, [
  /*#__PURE__*/_createElementVNode("h3", null, "FAQs")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("a", {
  href: "/help/changelog",
  class: "box border-rounded"
}, [
  /*#__PURE__*/_createElementVNode("h3", null, "Change Log")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", null, "Breakdown of Help Section", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h4", null, "How to Access the Dashboard", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("ul", { class: "faq-list" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "el-icon el-icon-document-checked" }),
    /*#__PURE__*/_createElementVNode("a", { href: "/help/usingthesite#url" }, "URL")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "el-icon el-icon-document-checked" }),
    /*#__PURE__*/_createElementVNode("a", { href: "/help/usingthesite#sidebar" }, "Sidebar Menu")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "el-icon el-icon-document-checked" }),
    /*#__PURE__*/_createElementVNode("a", { href: "/help/usingthesite#home" }, "Home Screen")
  ])
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h4", null, "How the Dashboards work", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("ul", { class: "faq-list" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "el-icon el-icon-document-checked" }),
    /*#__PURE__*/_createElementVNode("a", { href: "/help/usingthesite#filter" }, "Filter")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "el-icon el-icon-document-checked" }),
    /*#__PURE__*/_createElementVNode("a", { href: "/help/usingthesite#sort" }, "Sort")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "el-icon el-icon-document-checked" }),
    /*#__PURE__*/_createElementVNode("a", { href: "/help/usingthesite#customize" }, "Customize")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "el-icon el-icon-document-checked" }),
    /*#__PURE__*/_createElementVNode("a", { href: "/help/usingthesite#date" }, "Date Range")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "el-icon el-icon-document-checked" }),
    /*#__PURE__*/_createElementVNode("a", { href: "/help/usingthesite#favorites" }, "Favorites")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "el-icon el-icon-document-checked" }),
    /*#__PURE__*/_createElementVNode("a", { href: "/help/usingthesite#excel" }, "Excel")
  ])
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h4", null, "Dashboard Column Titles, Options & Explanations", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("ul", { class: "faq-list" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "el-icon el-icon-document-checked" }),
    /*#__PURE__*/_createElementVNode("a", { href: "/help/dashboards#transaction" }, "Transaction Dashboard")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "el-icon el-icon-document-checked" }),
    /*#__PURE__*/_createElementVNode("a", { href: "/help/dashboards#transactiondetail" }, "Transaction Detail Dashboard")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "el-icon el-icon-document-checked" }),
    /*#__PURE__*/_createElementVNode("a", { href: "/help/dashboards#reconciliation" }, "Reconciliation Dashboard")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "el-icon el-icon-document-checked" }),
    /*#__PURE__*/_createElementVNode("a", { href: "/help/dashboards#reconciliationdetail" }, "Reconciliation Detail Dashboard")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "el-icon el-icon-document-checked" }),
    /*#__PURE__*/_createElementVNode("a", { href: "/help/dashboards#commission" }, "Commission Dashboard")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "el-icon el-icon-document-checked" }),
    /*#__PURE__*/_createElementVNode("a", { href: "/help/dashboards#commissiondetail" }, "Commission Detail Dashboard")
  ])
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h4", null, "Detail Dashboard Messages and Statuses", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("ul", { class: "faq-list" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "el-icon el-icon-document-checked" }),
    /*#__PURE__*/_createElementVNode("a", { href: "/help/dashboards#detaildashboard" }, "Explanations")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_DashboardLayout = _resolveComponent("DashboardLayout")!

  return (_openBlock(), _createBlock(_component_DashboardLayout, null, {
    header: _withCtx(() => [
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _hoisted_1,
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    content: _withCtx(() => [
      _createVNode(_component_el_row, { gutter: 20 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_divider, { class: "no-border" }),
              _hoisted_7
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, { gutter: 20 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _hoisted_8,
              _hoisted_9
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _hoisted_10,
              _hoisted_11
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _hoisted_12,
              _hoisted_13
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _hoisted_14,
              _hoisted_15
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}